import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  singleEpisode: '',
};

export const episodeSlice = createSlice({
  name: 'episode',
  initialState,
  reducers: {
    singleEpisode: (state, action) => {
      state.singleEpisode = action.payload
    },
  },
});

export const { singleEpisode } = episodeSlice.actions;

export default episodeSlice.reducer;
